declare var Cookies: any;

export class CookieHelper {
    public static get(name: string): any {
        return Cookies.get(name);
    }

    public static set(name: string, value: any) {
        Cookies.set(name, value, { expires: 365 });
    }
}
